module.exports = __webpack_public_path__ + "static/urbanArrow-42420557782d1636ed8ac5a46d594959.mp4";